<template>
  <div class="flex-1 mt-1 bg-gray-100 px-4 pt-12 mb-20 items-center">
    <div class="bg-white w-full rounded-lg shadow">
      <div class="h-20 py-3 flex items-center border-gray-200 p-6 mt-2">
        <div class="flex">
          <router-link
            :class="$colors.primary"
            class="rounded-full flex justify-center items-center w-8 h-8 mt-1 mr-3"
            to="/internalexpeditions"
          >
            <i class="material-icons mx-2">chevron_left</i>
          </router-link>
          <div v-if="!formData._id" class="text-2xl font-bold text-primary-500">
            {{ $t('new_expidition') }} interne
          </div>
          <div v-else class="text-2xl font-bold text-primary-500">
            {{ $t('edit_expidition') }}
          </div>
        </div>
      </div>

      <div class="">
        <div class="bg-white rounded-lg p-6 pt-2 relative min-h-600">
          <loading :active.sync="loading" :is-full-page="fullPage"></loading>
          <div>
            <!-- ************************************************************************************ -->
            <!-- ************************************Select Colis***********************************-->
            <div class="px-6 mt-3">
              <div class="flex w-full space-x-2">
                <div
                  class="flex w-full justify-center shadow-xs border border-gray-400 border-dashed items-center h-auto p-4 my-1 mb-1 rounded-lg"
                >
                  <div
                    v-if="
                      !formData._id ||
                        (formData._id && formData.status != 'received')
                    "
                    class="input-group w-45"
                    id="adv-search"
                  >
                    <input
                      type="text"
                      class="form-control"
                      placeholder="id produit ..."
                      v-model="searchText"
                      @keyup.enter="trigger"
                    />
                    <div class="input-group-btn">
                      <div class="btn-group" role="group">
                        <button
                          type="button"
                          class="btn btn-primary"
                          @click="search"
                          ref="sendReply"
                        >
                          <svg
                            aria-hidden="true"
                            class="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                            ></path>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="formData._id"
                    class="border ml-4 w-45 seller-select h-10 hover:border-orange-500 focus-within:border-orange-500 focus-within:text-primary-500 transition-all duration-500 relative rounded p-1"
                  >
                    <div
                      class="-mt-4 absolute tracking-wider px-1 capitalize text-xs"
                    >
                      <p>
                        <label for="seller" class="bg-white text-gray-700 px-1"
                          >{{ $t('status') }}
                          <span :class="$colors.required">*</span></label
                        >
                      </p>
                    </div>
                    <p>
                      <select
                        name="status"
                        autocomplete="type"
                        v-model="formData.status"
                        class="py-2 text-xs capitalize px-2 outline-none block h-full w-full bg-white"
                      >
                        <option class="bg-white" selected :value="null">
                          {{ $t('status') }}
                        </option>
                        <option
                          class="bg-white text-gray-600"
                          v-for="(value, index) in status"
                          :key="index"
                          :value="value"
                        >
                          {{ value }}
                        </option>
                      </select>
                    </p>
                  </div>
                </div>
                <!-- ****************************** Order Information *********************************************-->
              </div>

              <!-- ********************************************************Product Table assigned to expedition **********************************-->
              <div class="flex w-full">
                <div class="flex space-x-2 w-full shadow-xs mt-1 rounded-lg">
                  <div
                    v-if="formData.status != 'received'"
                    class="flex w-full justify-between items-center h-auto p-6"
                  >
                    <div class="flex w-full">
                      <span class="rounded-full h-12 w-12 bg-gray-200">
                        <i class="material-icons p-3 text-primary-500"
                          >local_mall</i
                        >
                      </span>
                      <div class="ml-3 w-full p-2 pb-8">
                        <div
                          class="w-full flex text-base font-semibold text-gray-600"
                        >
                          <p>{{ $t('products') }}</p>
                        </div>

                        <div class="div-table mt-4 overflow-x-auto">
                          <div class="div-table-row header">
                            <div style="width: 10%" class="div-table-col p-2">
                              ID
                            </div>
                            <div class="div-table-col p-2">
                              {{ $t('name') }}
                            </div>
                            <div style="width: 50%" class="div-table-col p-2">
                              Warehouses
                            </div>
                            <div
                              style="width: 10%; text-align: center"
                              class="div-table-col p-2"
                            >
                              {{ $t('actions') }}
                            </div>
                          </div>
                          <div
                            v-for="(item, index) in formData.details"
                            :key="index"
                            class="div-table-row"
                          >
                            <div
                              style="width: 10%"
                              class="div-table-col p-2 text-xs text-gray-900"
                            >
                              <b>{{ item.product.id }}</b>
                            </div>
                            <div
                              class="div-table-col p-2 text-xs text-gray-900"
                            >
                              {{ item.product.name }}
                            </div>
                            <div
                              style="width: 50%"
                              class="div-table-col p-2 text-xs text-gray-900"
                            >
                              <v-select
                                class="input-style"
                                @input="setSelectedW"
                                v-model="item.dataWarehouses"
                                :options="warehouses"
                                label="name"
                                placeholder="Warehouses ..."
                                multiple
                              >
                                <template slot="option" slot-scope="option">
                                  <img class="flag-img" :src="option.flag" />
                                  {{ option.name }}
                                </template>
                              </v-select>

                              <table
                                v-if="item.dataWarehouses.length > 0"
                                class="min-w-full w-full table-warehouses"
                              >
                                <thead>
                                  <th class="text-left pl-2">Warehouse</th>
                                  <th class="text-center">Quanity</th>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(ware, ind) in item.warehouses"
                                    :key="ind"
                                  >
                                    <td class="pl-2">
                                      {{ ware.warehouse.name }}
                                    </td>
                                    <td
                                      class="flex space-x-6 justify-center items-center"
                                      style="height: 36px"
                                    >
                                      <button
                                        :class="$colors.textPrimary"
                                        class="bg-primary-600 rounded-md w-6 h-6 flex items-center focus:outline-none"
                                        @click="addQuantity(index, ind)"
                                      >
                                        <span
                                          class="font-bold text-2xl text-white"
                                        >
                                          <i class="material-icons mt-2">add</i>
                                        </span>
                                      </button>

                                      <span
                                        :class="$colors.textPrimary"
                                        class="text-gray-700 text-sm h-6 flex items-center focus:outline-none"
                                      >
                                        <input
                                          class="focus:outline-none qte-inp text-center"
                                          type="text"
                                          v-model="ware.quantity.sent"
                                        />
                                      </span>

                                      <button
                                        :class="$colors.textPrimary"
                                        @click="removeQuantity(index, ind)"
                                        class="bg-primary-600 rounded-md w-6 h-6 text-white flex items-center focus:outline-none"
                                      >
                                        <span
                                          class="font-bold text-2xl text-white mt-1"
                                        >
                                          <i class="material-icons">remove</i>
                                        </span>
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div
                              style="width: 10%"
                              class="div-table-col p-2 text-xs text-gray-900 text-center"
                            >
                              <button
                                @click="removeProduct(item, index)"
                                :class="$colors.actionTable"
                                class="rounded-full focus:outline-none"
                              >
                                <i class="material-icons mx-1">delete</i>
                              </button>
                            </div>
                          </div>
                          <div
                            v-if="formData.details.length == 0"
                            class="div-table-row"
                          >
                            <div
                              class="w-full text-center p-2 text-xs bg-primary-100 text-primary-900"
                            >
                              <b>No product has been added</b>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!--*******************  Product Order ***************************************-->
                  <div
                    v-if="formData._id && formData.status == 'received'"
                    class="flex w-full justify-between items-center h-auto p-6"
                  >
                    <div class="flex w-full mt-1">
                      <span class="rounded-full h-12 w-12 bg-gray-200">
                        <i class="material-icons p-3 text-primary-400"
                          >local_mall</i
                        >
                      </span>
                      <div class="ml-5 w-full pb-4">
                        <div
                          class="text-base mt-1 font-semibold text-gray-600 pb-10"
                        >
                          {{ $t('expedition_products') }}
                        </div>
                        <div class="w-full space-y-4">
                          <div class="w-full">
                            <table class="min-w-full w-full">
                              <thead class="text-white">
                                <tr
                                  class="bg-primary-400 flex flex-col flex-no wrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0"
                                >
                                  <th class="p-2 justify-center">
                                    {{ $t('image') }}
                                  </th>
                                  <th class="p-2 justify-center">
                                    {{ $t('name') }}
                                  </th>
                                  <th class="p-2 justify-center">
                                    {{ $t('warehouses') }}
                                  </th>
                                </tr>
                              </thead>
                              <tbody class="flex-1 sm:flex-none">
                                <tr
                                  v-for="it in formData.details"
                                  :key="it._id"
                                  class="flex flex-col flex-no wrap sm:table-row mb-2 sm:mb-0"
                                >
                                  <td
                                    class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2"
                                  >
                                    <div>
                                      <img
                                        :alt="it.product.name"
                                        :src="
                                          it.product.picture ||
                                            'https://storeino.b-cdn.net/dev/templates/images/no-image.jpeg'
                                        "
                                        class="h-16 w-16 rounded-md mx-auto"
                                      />
                                    </div>
                                  </td>
                                  <td
                                    class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate"
                                  >
                                    <b>{{ it.product.name }}</b>
                                  </td>
                                  <td
                                    class="border-grey-light text-xs text-center border hover:bg-gray-100 p-2 truncate"
                                  >
                                    <table class="min-w-full">
                                      <thead>
                                        <tr>
                                          <th
                                            class="text-center bg-primary-400 p-1 border border-gray-300 text-left leading-4 text-white tracking-wider"
                                          >
                                            Warehouse
                                          </th>
                                          <th
                                            class="text-center bg-primary-400 p-1 border border-gray-300 text-left leading-4 text-white tracking-wider"
                                          >
                                            {{ $t('quantity_sent') }}
                                          </th>
                                          <th
                                            class="text-center bg-primary-400 p-1 border border-gray-300 text-left leading-4 text-white tracking-wider"
                                          >
                                            {{ $t('quantity_received') }}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody class="bg-white">
                                        <tr
                                          v-for="ware in it.warehouses"
                                          :key="ware._id"
                                        >
                                          <td
                                            class="p-1 border whitespace-no-wrap"
                                          >
                                            <div
                                              class="flex items-center"
                                            ></div>
                                            {{ ware.warehouse.name }}
                                          </td>
                                          <td
                                            class="border-grey-light text-xs text-center border hover:bg-gray-100 p-1 truncate"
                                          >
                                            <input
                                              id="sent"
                                              :disabled="CheckExpeditionRecived"
                                              type="number"
                                              min="0"
                                              v-model="ware.quantity.sent"
                                              class="py-1 border-4 border-light-orange-500 border-opacity-100 text-xs px-2 outline-none block h-full w-full"
                                            />
                                          </td>
                                          <td
                                            class="p-1 border whitespace-no-wrap"
                                          >
                                            <table class="min-w-full">
                                              <thead>
                                                <tr>
                                                  <th
                                                    class="text-center bg-gray-200 p-1 border border-gray-300 text-left leading-4 text-primary-500 tracking-wider"
                                                  >
                                                    Ok/Good
                                                  </th>
                                                  <th
                                                    class="text-center bg-gray-200 p-1 border border-gray-300 text-left leading-4 text-primary-500 tracking-wider"
                                                  >
                                                    Defective
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody class="bg-white">
                                                <tr>
                                                  <td
                                                    class="p-1 border whitespace-no-wrap"
                                                  >
                                                    <div
                                                      class="flex items-center"
                                                    >
                                                      <input
                                                        id="Received"
                                                        :disabled="
                                                          CheckExpeditionRecived
                                                        "
                                                        type="number"
                                                        min="0"
                                                        :max="
                                                          ware.quantity.sent
                                                        "
                                                        v-model="
                                                          ware.quantity.received
                                                        "
                                                        class="py-1 border-4 border-light-orange-500 border-opacity-100 text-xs px-2 outline-none block h-full w-full"
                                                      />
                                                    </div>
                                                  </td>
                                                  <td
                                                    class="p-1 border whitespace-no-wrap"
                                                  >
                                                    <div
                                                      class="flex items-center"
                                                    >
                                                      <input
                                                        id="Defective"
                                                        :disabled="
                                                          CheckExpeditionRecived
                                                        "
                                                        type="number"
                                                        min="0"
                                                        :max="
                                                          ware.quantity.sent
                                                        "
                                                        v-model="
                                                          ware.quantity
                                                            .defective
                                                        "
                                                        class="py-1 border-4 border-light-orange-500 border-opacity-100 text-xs px-2 outline-none block h-full w-full"
                                                      />
                                                    </div>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- ************************************************************************************************-->
            </div>
            <!-- button save -->
            <div class="w-full">
              <div class="pt-3 flex btn-bottom-toolbar justify-end">
                <button
                  :disabled="loading"
                  class="rounded focus:outline-none outline-none text-gray-100 px-3 w-1/6 py-2 bg-primary-600 hover:shadow-inner hover:bg-primary-700 transition-all duration-300"
                  @click="save"
                >
                  {{ $t('save') }}
                </button>
              </div>
            </div>
            <!--end button save -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const lastData = { data: {} };
export default {
  data() {
    return {
      formData: {
        country: null,
        details: [],
        // details: [{
        //   product: null,
        //   warehouses:[{warehouse:null,quantity: {sent: 0,},}],
        // }],
        quantity: { sent: 0 },
      },
      currentUser: {
        role: {},
      },
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 1,
        per_page: 0,
      },
      searchText: '',
      products: [],
      warehouses: [],
      options: this.$countries,
      wharhouse: null,
      loading: false,
      fullPage: false,
      CheckExpeditionRecived: false,
      status: ['expedited', 'received', 'cancelled'],
    };
  },
  async mounted() {
    await this.getUser();
    await this.getwharhouseId();
    await this.getWarehouses();
    await this.dataToEdit();
  },
  computed: {
    warhouseSelected() {
      return this.$store.getters['wharhouse/warhouseSelected'];
    },
  },
  watch: {
    warhouseSelected: async function(oldVal, newVal) {
      await this.getwharhouseId();
      await this.getWarehouses();
    },
  },
  methods: {
    async getwharhouseId() {
      await this.$store.dispatch('wharhouse/getwharhouseId').then(res => {
        this.wharhouse = res;
      });
    },
    async setSelectedW(warhouse) {
      if (warhouse) {
        
        this.formData.details.forEach(product => {
          if (product.dataWarehouses.length == 0) {
            product.warehouses = [];
          }
          product.dataWarehouses.forEach(ware => {
            var index = product.warehouses.findIndex(
              x => x.warehouse._id.toString() === ware._id.toString(),
            );
            
            if (index === -1)
              product.warehouses.push({
                warehouse: ware,
                quantity: { sent: 0 },
              });
            // else product.warehouses = product.warehouses.filter(function( obj ) {return obj.warehouse._id.toString() == ware._id.toString();});
          });
          
          if (product.dataWarehouses.length < product.warehouses.length) {
            
            product.warehouses.forEach(ware => {
              var index = product.dataWarehouses.findIndex(
                x => x._id.toString() === ware.warehouse._id.toString(),
              );
              if (index === -1)
                product.warehouses = product.warehouses.filter(function(obj) {
                  return (
                    obj.warehouse._id.toString() !=
                    ware.warehouse._id.toString()
                  );
                });
            });
          }
        });
      }
      
    },
    trigger() {
      this.$refs.sendReply.click();
    },
    async search() {
      if (this.searchText) {
        const editData = await this.$server.get('products', {
          idProduit: this.searchText,
          warehouse: this.wharhouse._id,
        });
        if (editData.content && editData.content.length > 0) {
          var index = this.formData.details.findIndex(
            x => x.product._id.toString() == editData.content[0]._id.toString(),
          );
          if (index === -1)
            this.formData.details.push({
              product: editData.content[0],
              warehouses: [],
              dataWarehouses: [],
            });
          else alert(`Product aready exist in the list`, 'warning');
          this.searchText = '';
        } else alert(`Product not found`, 'warning');
        
      }
    },
    async CheckQteSentExist(item) {
      this.CheckExpeditionRecived = false;
      if (item.status == 'received') {
        for (let i in item.details) {
          const filters = {
            product: item.details[i].product._id,
            internalexpedition: item._id,
          };
          const res = await this.$server.search('stockHistories', filters);
          if (typeof res.content.results !== 'undefined') {
            this.CheckExpeditionRecived = true;
          }
        }
      }
    },
    async getwharhouse(country) {
      const resW = await this.$server.get('warehouses', {
        country: country,
        is_primary: true,
      });
      if (resW.content) return resW.content;
    },
    searchSellers: _.debounce(async function(search, event) {
      if (this.selectToContry) {
        const filter = {
          type: 'Seller',
          limit: this.limit,
          countries: this.selectToContry,
          name: search,
        };
        const res = await this.$server.find('users', filter);

        if (res && res.content.results) this.sellers = res.content.results;
        else this.sellers = [];
      } else alert('Please select a country !', 'warning');
    }, 500),

    exceptDes(text) {
      if (text && text.length > 60) text = text.substring(0, 60) + '...';
      return text;
    },

    async getUser() {
      const res = await this.$server.me('users');
      
      if (res.content) this.currentUser = res.content;
      else this.currentUser = {};
    },
    getElementInArray(data, value) {
      var result = data.filter(function(o) {
        let whar = o.warehouse;
        if (o.warehouse._id) whar = o.warehouse._id;
        return whar == value.toString();
      });
      return result ? result[0] : null; // or undefined
    },
    async save() {
      if (this.formData._id) {
        this.formData.country = this.wharhouse.country;
        for (let i in this.formData.details) {
          if (this.formData.details[i].dataWarehouses.length > 0) {
            if (
              this.formData.details[i].dataWarehouses.length !=
              this.formData.details[i].warehouses.length
            ) {
              alert(
                "une erreur inattendue s'est produite veuillez réessayer ultérieurement",
                'warning',
              );
              return false;
              break;
            }
          } else {
            alert(
              `Warehouses required pour ce produit: ${this.formData.details[i].product.name}`,
              'warning',
            );
            return false;
            break;
          }
        }

        this.loading = true;
        const data = await this.$server.update(
          'internalexpeditions',
          this.formData,
        );
        this.loading = false;
        if (data && data._id) {
          alert(this.$t('expedition_updated'), 'success');
          await this.dataToEdit();
        } else alert(data, 'warning');
      } else {
        this.formData.country = this.wharhouse.country;
        if (this.checkData()) {
          
          for (let i in this.formData.details) {
            if (this.formData.details[i].dataWarehouses.length > 0) {
              if (
                this.formData.details[i].dataWarehouses.length !=
                this.formData.details[i].warehouses.length
              ) {
                alert(
                  "une erreur inattendue s'est produite veuillez réessayer ultérieurement",
                  'warning',
                );
                return false;
                break;
              }
            } else {
              alert(
                `Warehouses required pour ce produit: ${this.formData.details[i].product.name}`,
                'warning',
              );
              return false;
              break;
            }
          }

          this.loading = true;
          const data = await this.$server.create(
            'internalexpeditions',
            this.formData,
          );
          this.loading = false;
          if (data && data._id) {
            this.formData = { details: [] };
            alert(this.$t('expedition_created'), 'success');
          }
        } else alert(this.$t('all_required_field'), 'warning');
      }
    },
    async getWarehouses() {
      if (this.wharhouse && this.wharhouse.country) {
        const filter = { limit: 1000, country: this.wharhouse.country };
        const res = await this.$server.search('warehouses', filter);
        if (res.content.results) {
          this.warehouses = res.content.results;
          //this.warehouses= this.warehouses.map(v => ({...v, quantity: {sent:0}}))
          // 
        } else this.warehouses = [];
      }
    },
    checkData() {
      if (this.formData.country && this.formData.details.length > 0)
        return true;
      else return false;
    },
    removeProduct(data, index) {
      this.$confirm('Are you sure you want to delete this product?').then(
        async res => {
          let pos = this.formData.details
            .map(function(e) {
              return e.product._id;
            })
            .indexOf(data._id);

          this.formData.details.splice(pos, 1);
          data.product.check = false;
          alert(this.$t('product_deleted'), 'success');
        },
      );
    },
    addQuantity(indexDetails, indexWarehouse) {
      
      this.formData.details[indexDetails].warehouses[indexWarehouse].quantity
        .sent++;
      
    },
    removeQuantity(indexDetails, indexWarehouse) {
      if (
        this.formData.details[indexDetails].warehouses[indexWarehouse].quantity
          .sent <= 1
      ) {
      } else {
        this.formData.details[indexDetails].warehouses[indexWarehouse].quantity
          .sent--;
      }
    },
    async dataToEdit() {
      if (this.$route.params.id) {
        const editData = await this.$server.get('internalexpeditions', {
          id: this.$route.params.id,
        });
        this.formData = editData.content;
        
        for (let i = 0; i < this.formData.details.length; i++) {
          if (!this.formData.details[i].dataWarehouses)
            this.formData.details[i].dataWarehouses = this.formData.details[
              i
            ].warehouses.map(el => el.warehouse);
        }
        
        this.wharhouse = await this.getwharhouse(this.formData.country);
        await this.CheckQteSentExist(this.formData);
        this.formData.date = this.$moment(this.formData.date).format(
          'yyyy-MM-DD',
        );
        if (this.formData.arrivalDate)
          this.formData.arrivalDate = this.$moment(
            this.formData.arrivalDate,
          ).format('yyyy-MM-DD');
      }
    },
  },

  /************************************* Pagination **************************************************/
};
</script>

<style scoped>
.input-style {
  padding: 0;
}
.w-45 {
  width: 45%;
}
.qte-inp {
  background-color: inherit;
}
.table-warehouses {
  border-collapse: separate;
  border-spacing: 0.25em 5px;
  page-break-inside: auto;
}
.table-warehouses thead {
  display: table-header-group;
}
.table-warehouses tr {
  page-break-inside: avoid;
  page-break-after: auto;
}
.table-warehouses td {
  padding: 0 0.5em;
  text-align: left;
}
.table-warehouses th {
  background-color: #805ad5;
  color: #fff;
  padding: 0 0.5em;
  text-transform: uppercase;
  line-height: 24px;
  font-size: 12px;
}
.table-warehouses th:not(:last-child) {
  border-bottom: 2px solid rgba(0, 0, 0, 0.1);
}
.div-table {
  display: table;
  width: 100%;
  border: 1px solid #666666;
  border-spacing: 5px; /* cellspacing:poor IE support for  this */
}
.div-table-row {
  display: table-row;
  width: auto;
  clear: both;
  vertical-align: middle;
  line-height: 36px;
}
.div-table-row.header {
  line-height: inherit;
}
.div-table-col {
  float: left; /* fix for  buggy browsers */
  display: table-column;
  width: 30%;
  border-top: 1px solid black;
}
.div-table-row.header .div-table-col {
  background-color: #99b782;
  background-color: #805ad5;
  color: #fff;
}
@media screen and (min-width: 768px) {
  #adv-search {
  }
}
.min-h-600 {
  min-height: 600px;
}
.input-group {
  position: relative;
  display: table;
  border-collapse: separate;
}
svg {
  position: relative;
  top: 1px;
  display: inline-block;
}
.input-group .form-control:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group .form-control {
  display: table-cell;
}
.input-group .form-control {
  position: relative;
  z-index: 2;
  float: left;
  width: 100%;
  margin-bottom: 0;
  height: 39px;
  padding: 6px 12px;
  font-size: 14px;
  line-height: 1;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
  box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
  -webkit-transition: border-color ease-in-out 0.15s,
    -webkit-box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.input-group-btn {
  position: relative;
  font-size: 0;
  white-space: nowrap;
}
.input-group-btn {
  width: 1%;
  white-space: nowrap;
  vertical-align: middle;
}
.input-group-btn {
  display: table-cell;
}
.input-group-btn:last-child > .btn-group {
  margin-left: -1px;
}
.input-group-btn .btn-group {
  display: flex !important;
}
.btn-group {
  position: relative;
  vertical-align: middle;
}
.input-group-btn:last-child > .btn-group > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group .btn:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  float: left;
}
.btn-primary {
  color: #fff;
  background-color: #805ad5;
  border-color: #805ad5;
}
.btn {
  display: inline-block;
  padding: 5px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 2;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
}
button {
  overflow: visible;
}
.flag-img {
  display: inline-block;
  height: 16px;
  width: 16px;
  vertical-align: text-top;
  line-height: 16px;
  margin-right: 5px;
}
.left-3 {
  left: 0.75rem;
}
.top-2 {
  top: 0.1rem;
}
.vs__dropdown-toggle {
  border: none;
}
.modal-header {
  background: #226faa;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#226faa),
    color-stop(37%, #2989d8),
    to(#72c0d3)
  );
  background: linear-gradient(to right, #226faa 0, #2989d8 37%, #72c0d3 100%);
  border-radius: 6px;
  color: #fff;
  padding: 18px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-color: transparent;
  border-bottom: 1px solid #e5e5e5;
}

.table.item thead {
  background: #3182ce4f;
  color: #fff;
  border: 0;
}

.toggle__dot {
  transition: all 0.3s ease-in-out;
}

.seller-select .vs__dropdown-toggle {
  border: none;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #68d391;
}

/* animation for vue transition tag */
dialog[open] {
  animation: appear 0.15s cubic-bezier(0, 1.8, 1, 1.8);
}

dialog::backdrop {
  background: linear-gradient(45deg, rgba(0, 0, 0, 0.5), rgba(54, 54, 54, 0.5));
  backdrop-filter: blur(3px);
}

@keyframes appear {
  from {
    opacity: 0;
    transform: translateX(-3rem);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.btn-bottom-toolbar {
  position: fixed;
  bottom: 0;
  padding: 12px;
  padding-right: 70px;
  margin: 0px 0 0 -40px;
  box-shadow: 0 -4px 1px -4px rgb(0 0 0 / 10%);
  background: #fff;
  width: calc(100% - 211px);
  z-index: 60;
  border-top: 1px solid #ededed;
}
.toggle__dot {
  top: -0.25rem;
  left: -0.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #63b3ed;
}
</style>
